module.exports = __webpack_public_path__ + "static/media/4.b843cbb2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Approach/components/Carousel/video/4.mp4
// module id = 528
// module chunks = 0